import React, { Component } from 'react'
import { policies, companies, rightsParamSets } from '@services/api'
import { Select, Table, Button, Icon, Input } from 'antd'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'

@inject((store: any) => {
    const { collectionsStore, popupStore } = store
    return { collectionsStore, popupStore }
})
@observer
class PoliciesTable extends Component<any, any> {
    constructor(props) {
        super(props)
        this.getDataSource = this.getDataSource.bind(this)
        this.state = {
            policies: [],
            categories: null,
            companies: null,
            sets: null,
            filters: { text: '' }
        }
    }
    componentDidMount() {
        policies
            .getList({ right_param_set_id: this.props.right_param_set_id })
            .then(res => {
                this.setState({
                    policies: res.data.policies,
                    categories: [
                        ...new Set(
                            Object.values(res.data.categories)
                                .filter(val => val)
                                .map(txt => !!txt && txt.trim())
                                .sort(new Intl.Collator('he').compare)
                        )
                    ]
                })
            })
            .catch(err => console.log(err))

        companies
            .getList()
            .then(res => this.setState({ companies: res.data }))
            .catch(err => console.log(err))

        rightsParamSets
            .getList()
            .then(res => this.setState({ sets: res.data }))
            .catch(err => console.log(err))
    }

    getDataSource = () => {
        const {
            policies,
            filters: { category, company, set, text }
        } = this.state
        const {
            collectionsStore,
            propCallback,
            popupStore: { info }
        } = this.props

        return [...policies].filter(policy => {
            let isFromPopupCheck = !!propCallback
                ? policy.type == 'PRIVATE' || policy.type == 'GROUP'
                    ? collectionsStore.collection.collectionPolicies
                        ? !(
                              collectionsStore.collection.collectionPolicies
                                  .map(pol => pol.policy_id)
                                  .indexOf(policy.id) + 1
                          )
                        : info.policy
                        ? policy.id != info.policy.id
                        : false
                    : false
                : true

            return (
                (!!company ? policy.company_id == company : true) &&
                (!!set ? policy.right_param_set_id == set : true) &&
                (policy.category_name && !!category
                    ? policy.category_name.trim() == category
                    : !policy.category_name && !!category
                    ? false
                    : true) &&
                policy.name.includes(text) &&
                isFromPopupCheck
            )
        })
    }

    render() {
        const { policies, categories, filters, companies, sets } = this.state
        const { history, propCallback } = this.props
        let columns = [
            {
                title: 'שם',
                key: 'name',
                width: 60,
                align: 'center',
                render: (_, record) => <span key={record.name}>{record.name}</span>
            },
            {
                title: 'קטגוריה',
                key: 'category',
                width: 60,
                align: 'center',
                render: (_, record) => <span key={record.name}>{record.category_name}</span>
            },
            {
                title: 'חברה',
                key: 'company',
                width: 60,
                align: 'center',
                render: (_, record) => (
                    <span key={record.name}>{companies.find(({ id }) => id == record.company_id).name}</span>
                )
            },
            {
                title: 'סט',
                key: 'set',
                width: 60,
                align: 'center',
                render: (_, record) => <span key={record.name}>{record.right_param_set_name}</span>
            },
            {
                title: propCallback ? 'קשר פוליסה' : 'עריכת פוליסה',
                key: 'edit',
                width: 10,
                align: 'center',
                render: (_, record) => (
                    <Button
                        key={record.name}
                        onClick={async () =>
                            propCallback
                                ? propCallback(record)
                                : history.push(`/insurance/${record.company_id}/${record.id}`)
                        }
                    >
                        <Icon type={propCallback ? 'check' : 'edit'} />
                    </Button>
                )
            }
        ]
        return policies.length && categories && sets && companies ? (
            <div style={{ flexDirection: 'column' }}>
                <div style={{ flexDirection: 'row' }}>
                    <Select
                        id="set_company_filter"
                        value={!!filters.company ? companies.find(({ id }) => id == filters.company).name : 'כל החברות'}
                        style={{ width: '20%' }}
                        placeholder="בחר חברה"
                        onChange={(_, field) =>
                            this.setState({
                                filters: {
                                    ...this.state.filters,
                                    company: field.key && field.key !== 'null' ? field.key : null
                                }
                            })
                        }
                    >
                        <Select.Option value={null} key={null}>
                            כל החברות
                        </Select.Option>
                        {companies
                            .sort((a, b) => new Intl.Collator('he').compare(a.name, b.name))
                            .map(slot => (
                                <Select.Option value={slot.name} key={slot.id}>
                                    {slot.name}
                                </Select.Option>
                            ))}
                    </Select>
                    <Select
                        id="set_category_filter"
                        value={!!filters.category ? filters.category : 'כל הקטגוריות'}
                        style={{ width: '20%' }}
                        placeholder="בחר קטגוריה"
                        onChange={(_, field) =>
                            this.setState({
                                filters: {
                                    ...filters,
                                    category: field.key && field.key !== 'null' ? field.key : null
                                }
                            })
                        }
                    >
                        <Select.Option value={null} key={null}>
                            כל הקטגוריות
                        </Select.Option>
                        {categories.map(slot => (
                            <Select.Option value={slot} key={slot}>
                                {slot}
                            </Select.Option>
                        ))}
                    </Select>
                    <Select
                        id="set_company_filter"
                        value={!!filters.set ? sets.find(({ id }) => id == filters.set).name : 'כל הסטים'}
                        style={{ width: '20%' }}
                        placeholder="בחר סט"
                        onChange={(_, field) =>
                            this.setState({
                                filters: {
                                    ...filters,
                                    set: field.key && field.key !== 'null' ? field.key : null
                                }
                            })
                        }
                    >
                        <Select.Option value={null} key={null}>
                            כל הסטים
                        </Select.Option>
                        {sets
                            .sort((a, b) => new Intl.Collator('he').compare(a.name, b.name))
                            .map(slot => (
                                <Select.Option value={slot.name} key={slot.id}>
                                    {slot.name}
                                </Select.Option>
                            ))}
                    </Select>
                    <Input
                        value={filters.text}
                        placeholder="לפי טקסט"
                        onChange={e => this.setState({ filters: { ...filters, text: e.target.value } })}
                        style={{ width: '40%' }}
                    />
                </div>
                <Table rowKey="id" columns={columns} dataSource={this.getDataSource()} />
            </div>
        ) : (
            <Icon type="loading" />
        )
    }
}

export default withRouter(PoliciesTable)
